import React from 'react';
import {RFValue} from 'react-native-responsive-fontsize';

import {openFinesModal} from '../../../context/finesFlow';
import {Card, CardIcon, CardText, IconCircle} from './styles';

export function FinesReminderCard() {
  return (
    <Card
      activeOpacity={0.9}
      onPress={openFinesModal}
      accessibilityRole="button"
      accessibilityLabel="Parcele multas e débitos veiculares. Toque para saber mais.">
      <IconCircle>
        <CardIcon name="car" size={RFValue(18)} />
      </IconCircle>
      <CardText numberOfLines={2}>Parcele multas e débitos do seu veículo</CardText>
      <CardIcon name="chevron-forward" size={RFValue(16)} />
    </Card>
  );
}
